import { useState, useRef, useEffect } from 'react';
import { FaPlay, FaPause, FaBookmark, FaRegBookmark } from 'react-icons/fa';
import quranApi from '../../api/quranApi';

const AyahDisplay = ({
    ayah,
    surah,
    reciterId,
    isPlaying,
    onPlay,
    onPause,
    onEnded,
    isBookmarked,
    onToggleBookmark,
}) => {
    const audioRef = useRef(null);
    const [audioUrl, setAudioUrl] = useState(null);

    useEffect(() => {
        if (reciterId && ayah) {
            const url = quranApi.getAyahAudioUrl(reciterId, ayah.number);
            setAudioUrl(url);
        }
    }, [reciterId, ayah]);

    useEffect(() => {
        if (isPlaying && audioRef.current) {
            audioRef.current.play().catch(e => console.error("Audio play error", e));
        } else if (!isPlaying && audioRef.current) {
            audioRef.current.pause();
        }
    }, [isPlaying]);

    const handleEnded = () => {
        if (onEnded) onEnded();
        // Don't pause here, let parent handle state
    };

    return (
        <div className={`ayah-container ${isPlaying ? 'playing' : ''}`}>
            <div className="ayah-actions">
                <span className="ayah-number">
                    {surah.number}:{ayah.numberInSurah}
                </span>
                <button className="btn-icon" onClick={() => onToggleBookmark(ayah)}>
                    {isBookmarked ? <FaBookmark /> : <FaRegBookmark />}
                </button>
                <button className="btn-icon" onClick={isPlaying ? onPause : onPlay}>
                    {isPlaying ? <FaPause /> : <FaPlay />}
                </button>
            </div>

            <div className="ayah-content">
                <p className="ayah-arabic">{ayah.text}</p>
                <p className="ayah-translation">{ayah.translation}</p>
            </div>

            {audioUrl && (
                <audio
                    ref={audioRef}
                    src={audioUrl}
                    onEnded={handleEnded}
                    preload="metadata"
                />
            )}
        </div>
    );
};

export default AyahDisplay;
